import { Flex, Loader } from '@coolblue-development/freddy';
import { ReactElement } from 'react';

export default function ContainedLoader({ height }: { height: number }): ReactElement {
  return (
    <Flex
      sx={{
        position: 'relative',
        height: `${height}px`
      }}
      justifyContent='center'
    >
      <Loader />
    </Flex>
  );
}
